export default __webpack_public_path__ + "static/media/Sunset-Turbines-Narrow-1920px-720px.14fdde5e.jpg";